import React, { memo, useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuthContext from '../providers/authProvider';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from './LanguageSwitcher';
import { organizationsList} from '../services/organizations';
import { clubsCount } from '../services/users';

const NavBarOrganization= () => {
  const { t } = useTranslation();
  const { logout } = useAuthContext();
  const location = useLocation();
  const { organization } = useAuthContext();
  const [organizations, setOrganizations] = useState([]);
  const [clubs, setClubs] = useState([]);
  
  useEffect(() => {
    const getClubs = async () => {
      try {
        const res = await clubsCount();
        setClubs(res.clubs);
      } catch (error) {
        console.error("Failed to fetch clubs:", error);
      }
    };

    getClubs();
  }, []);

  useEffect(() => {
    const fetchOrganizations = async () => {
      const { organizations } = await organizationsList();
      setOrganizations(organizations);
    };
    fetchOrganizations();
  }, []);

  const navClass = (path) => {
    return location.pathname.includes(path)
      ? "sidebar-nav active sidebar-menuitem"
      : "sidebar-nav sidebar-menuitem";
  };

  const NavLink = ({ to, children }) => (
    <Link className={navClass(to)} to={to}>
      {children}
    </Link>
  );

  return (
    <div>
      <div className="top-bar">
        <div className="logo">
          <img src="/images/logo.png" alt="logo" />
          Supercoach
        </div>
        <div className="logout">
          {organizations.length > 1 && (
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/organizations">
                {t("organization.switch.title")}
              </Link>
            </div>
          )}
          {clubs && (
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/clubs">{t("common.switch-club")}</Link>
            </div>
          )}
          <div className="sidebar-menuitem sidebar-nav">
            <a onClick={logout} href="">{t("common.signout")}</a>
          </div>
        </div>
      </div>
      <div id="sidebar-wrapper">
        {organization && (
          <Link
            className={`${navClass("/club_admin/organization")} sidebar-label sidebar-menuitem-profile`}
            to="/club_admin/organization"
          >
            <div className="club">{t("common.organization")}</div>
            <h4>{organization.name}</h4>
          </Link>
        )}
        <NavLink to="/club_admin/clubs_organization">{t("common.clubs")}</NavLink>
        <NavLink to="/club_admin/members">{t("common.members")}</NavLink>

        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default NavBarOrganization;